import React, { useState } from 'react';
import CustomNavbar from '../../../components/navbar';
import Sidebar from '../../../components/sidebar';
import MainContent from '../../../components/mainContent';
import {  Row,  Container } from 'react-bootstrap';
import Vendas from '../Ecommerce/vendas'



const VendasIndex = () => {

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [key, setKey] = useState('produto');
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };


    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <Sidebar isOpen={isSidebarOpen} />

            {/* Área de conteúdo */}
            <div className={`main-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                {/* Navbar */}
                <CustomNavbar toggleSidebar={toggleSidebar} />

                {/* Conteúdo principal */}
                <MainContent>
                    <Container>
                        <Row>
                           
                            <Vendas/>

                        </Row>
                    </Container>
                </MainContent>
            </div>
        </div>
    );
};

export default VendasIndex;
